export interface Testimonial {
  id: string
  name: string
  role: string
  company: string
  avatar: string
  content: string
  verified: boolean
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Marcus Thompson',
    role: 'Real Estate Investor',
    company: 'Thompson Properties',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'AcquireFlow helped me close 12 deals in my first 90 days. The AI targeting is incredible—every offer goes to a motivated seller.',
    verified: true,
  },
  {
    id: '2',
    name: 'Sarah Chen',
    role: 'Wholesaler',
    company: 'Metro Deals LLC',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'I was spending 20+ hours a week on direct mail. Now it takes me 30 minutes to send 500 personalized offers. Game changer.',
    verified: true,
  },
  {
    id: '3',
    name: 'David Rodriguez',
    role: 'Fix & Flip Investor',
    company: 'Rodriguez Investments',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The response rate is 3x higher than my old campaigns. The AI knows exactly what to say to get sellers to respond.',
    verified: true,
  },
  {
    id: '4',
    name: 'Jennifer Martinez',
    role: 'Investment Firm Owner',
    company: 'Apex Real Estate Group',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'We scaled from 2 markets to 8 markets without hiring additional staff. AcquireFlow handles everything automatically.',
    verified: true,
  },
  {
    id: '5',
    name: 'Robert Kim',
    role: 'Real Estate Investor',
    company: 'Kim Capital',
    avatar:
      'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Best investment I made this year. One deal paid for the entire annual subscription 10x over.',
    verified: true,
  },
  {
    id: '6',
    name: 'Amanda Foster',
    role: 'Buy & Hold Investor',
    company: 'Foster Rentals',
    avatar:
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The deal pipeline feature keeps me organized. I never lose track of a hot lead anymore.',
    verified: true,
  },
  {
    id: '7',
    name: 'James Wilson',
    role: 'Real Estate Investor',
    company: 'Wilson Investments',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The automated follow-up system is brilliant. I never miss a callback and my conversion rate doubled.',
    verified: true,
  },
  {
    id: '8',
    name: 'Lisa Anderson',
    role: 'Property Flipper',
    company: 'Anderson Flips',
    avatar:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Found 3 off-market deals in my first month. The AI targeting is scary accurate.',
    verified: true,
  },
  {
    id: '9',
    name: 'Michael Brown',
    role: 'Rental Portfolio Owner',
    company: 'Brown Properties',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Expanded my rental portfolio by 8 properties this year thanks to AcquireFlow. Worth every penny.',
    verified: true,
  },
  {
    id: '10',
    name: 'Emily Turner',
    role: 'Real Estate Wholesaler',
    company: 'Turner Deals',
    avatar:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The response tracking keeps me on top of every lead. My closing rate went from 2% to 7%.',
    verified: true,
  },
  {
    id: '11',
    name: 'Daniel Lee',
    role: 'Investment Analyst',
    company: 'Lee Capital Group',
    avatar:
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'The analytics dashboard gives me insights I never had before. Data-driven decisions for every deal.',
    verified: true,
  },
  {
    id: '12',
    name: 'Rachel Green',
    role: 'Real Estate Investor',
    company: 'Green Investments',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    content:
      'Finally, a tool that actually saves time instead of creating more work. Highly recommend.',
    verified: true,
  },
]
